import { render, staticRenderFns } from "./ClientsDebug.vue?vue&type=template&id=684bc0ce"
import script from "./ClientsDebug.vue?vue&type=script&lang=js"
export * from "./ClientsDebug.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports